import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { CleaningAndSafetyPractice } from '__generated__/api';

export const getCleaningAndSafetyPracticesInput = (searchCriteria: SearchCriteriaModel): CleaningAndSafetyPractice[] | null => {
  if (searchCriteria.cleaningAndSafetyPractices?.length > 0) {
    return searchCriteria.cleaningAndSafetyPractices
      .map(type => {
        const result = CleaningAndSafetyPractice[CleaningAndSafetyPractice[type]];

        return result ? result : null;
      })
      .filter(type => type !== null);
  }

  return null;
};
